import { faCartShopping } from '@fortawesome/pro-light-svg-icons';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { faStar } from '@fortawesome/pro-light-svg-icons';
import { faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { faStar as faStarFilled } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import FormatedDate from 'components/desktop/_general/FormatedDate/FormatedDate';
import COLOR from 'enums/COLOR';
import { useFireAlertDelete } from 'hooks/useFireAlertDelete';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';

type IProps = RecipeErpViewComponentProps & { erpRecipe: ErpRecipe.Type };

export const AccordionHeader = ({ erpRecipe, ...props }: IProps) => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	const fireAlert = useFireAlertDelete();

	async function handleEdit(event: React.MouseEvent<SVGSVGElement, MouseEvent>) {
		event.stopPropagation();
		props.handlers.setErpRecipeId(erpRecipe.id);
	}
	async function handleDelete(event: React.MouseEvent<SVGSVGElement, MouseEvent>) {
		event.stopPropagation();
		fireAlert(() => props.handlers.deleteErpRecipe(erpRecipe.id));
	}

	return (
		<div className={classes.headerDiv}>
			<div>
				<span className={classes.date}>
					<FormatedDate date={erpRecipe.createdDateUtc} format={'L'} />
				</span>
				<strong>{erpRecipe.name ? erpRecipe.name : t('_general:UNKNOWN_TITLE')}</strong>
			</div>
			<div className={classes.icons}>
				<FontAwesomeIcon icon={faPen} size="lg" onClick={handleEdit} />
				<FontAwesomeIcon
					icon={faTrashCan}
					color={COLOR.DANGER}
					size="lg"
					onClick={handleDelete}
				/>
				<div style={{ display: 'none' }}>
					<FontAwesomeIcon icon={faStar} size="lg" />
					<FontAwesomeIcon icon={faStarFilled} size="lg" />
					<FontAwesomeIcon icon={faCartShopping} size="lg" />
					<FontAwesomeIcon icon={faCopy} size="lg" />
				</div>
			</div>
		</div>
	);
};

const useStyles = tss.create({
	headerDiv: {
		width: '100%',
		marginRight: '20px',
		display: 'flex',
		justifyContent: 'space-between',
		gap: '10px',
	},
	icons: {
		display: 'flex',
		gap: '15px',
	},
	image: {
		width: '44px',
		height: '44px',
		objectFit: 'contain',
		border: '1px solid #ccc',
	},
	date: {
		opacity: '0.3',
		marginRight: '15px',
	},
});
